"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const layout_1 = require("../layout");
const styled_1 = require("../styled");
const AkButton = require("@atlaskit/button").default;
const { ProgressTracker } = require("@atlaskit/progress-tracker");
const BodyDiv = styled_components_1.default.div `
  overflow-y: auto;
  margin: 10px;
`;
const ProgressTrackerDiv = styled_components_1.default.div `
  width: 50%;
  margin: 0 auto;
`;
const ButtonDiv = styled_components_1.default.div `
  width: 100%;
`;
class MultiStepWizard extends React.Component {
    constructor(props) {
        super(props);
        this.onBack = () => {
            let back = this.props.steps[this.state.stepNum].onBack;
            if (this.state.stepNum - 1 >= 0) {
                this.setState({ stepNum: this.state.stepNum - 1 });
            }
            if (back) {
                back();
            }
        };
        this.onNext = () => {
            let next = this.props.steps[this.state.stepNum].onNext;
            if (this.state.stepNum + 1 < this.props.steps.length) {
                this.setState({ stepNum: this.state.stepNum + 1 });
            }
            if (next) {
                next();
            }
        };
        this.onLink = (step, index) => () => {
            if (step.onLink) {
                step.onLink();
            }
            this.setState({ stepNum: index });
        };
        this.state = { stepNum: 0 };
    }
    render() {
        let { title, side, actions, steps } = this.props;
        let items = steps.map((s, index) => ({
            id: s.name,
            label: s.name,
            percentageComplete: index < this.state.stepNum ? 100 : 0,
            status: index < this.state.stepNum
                ? "visited"
                : index > this.state.stepNum
                    ? "unvisited"
                    : "current",
            noLink: s.noLink,
            onClick: this.onLink(s, index)
        }));
        let curStep = steps[this.state.stepNum];
        return (React.createElement(layout_1.PageLayout, { title: title || "", side: side, actions: actions, footer: React.createElement(ButtonDiv, null,
                React.createElement(styled_1.FloatRightDiv, null,
                    (curStep.backDisabled != "hide" && this.state.stepNum != 0) ||
                        curStep.onBack ? (React.createElement("span", null,
                        React.createElement(AkButton, { isDisabled: curStep.backDisabled, onClick: this.onBack }, "Back"),
                        React.createElement(styled_1.Separator, null))) : null,
                    curStep.nextDisabled != "hide" &&
                        this.state.stepNum + 1 < steps.length ? (React.createElement(AkButton, { appearance: "primary", isDisabled: curStep.nextDisabled, onClick: this.onNext }, "Next")) : curStep.nextDisabled != "hide" && curStep.onNext ? (React.createElement(AkButton, { appearance: "primary", onClick: this.onNext }, "Finish")) : null)) },
            React.createElement(ProgressTrackerDiv, null,
                React.createElement(ProgressTracker, { items: items })),
            React.createElement(BodyDiv, null, curStep.body)));
    }
}
exports.MultiStepWizard = MultiStepWizard;
